import Component from '@glimmer/component';
import { parseUserAgent } from '../lib/user-agent.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<span class=\'float-left\' ...attributes>\n  <div class=\'browser {{this.classNamesProperty}}\' title={{this.titleProperty}}></div>\n</span>\n");

class BbUserBrowserComponent extends Component {
  get classNamesProperty() {
    if (!this.args.user) {
      return;
    }
    const {
      browser
    } = parseUserAgent(this.args.user.user_agent);
    switch (browser.name) {
      case 'IE':
      case 'Edge':
        return 'IE';
      case undefined:
        return 'Others';
      default:
        return browser.name;
    }
  }
  get titleProperty() {
    if (!this.args.user) {
      return;
    }
    const {
      browser
    } = parseUserAgent(this.args.user.user_agent);
    return browser.name + ' ' + browser.version;
  }
}
setComponentTemplate(TEMPLATE, BbUserBrowserComponent);

export { BbUserBrowserComponent as default };
//# sourceMappingURL=bb-user-browser.js.map
